import { useContext } from "react";
import { Grid } from "@mui/material";
import { SimpleFormInput } from "./SimpleFormInput";
import { INewFeeForm } from "../../interfaces/configuration";
import { UserContext } from "../../contexts/userContext";
import ConditionsSection from "../fees/ConditionsSection";
import AppliedEntitiesSection from "../fees/AppliedEntitiesSection";
import FeeAmountSection from "../fees/FeeAmountSection";

const NewFeeForm = ({
  values,
  setValues,
  errors,
  defaultValues,
}: INewFeeForm) => {
  const {
    currentUser: { entity },
    marketplaceIntegrations: { integrations: merchants },
    carriers,
  } = useContext(UserContext);
  const baseInfo = { values, setValues };
  const handleChangeValue = (name: string, value: any) =>
    setValues({ ...values, [name]: value });

  return (
    <Grid container spacing={2} mb={2.5}>
      <Grid item xs={12}>
        <SimpleFormInput
          inputTitle="Nombre de regla"
          placeholder="Ingresar nombre de la regla"
          valueName="name"
          errors={errors.name}
          {...baseInfo}
          autoFocus
        />
      </Grid>

      <ConditionsSection
        {...{
          values,
          handleChangeValue,
          errors,
          baseInfo,
        }}
      />

      <AppliedEntitiesSection
        {...{
          entity,
          merchants,
          handleChangeValue,
          defaultValues,
          carriers,
        }}
      />

      <FeeAmountSection {...{ baseInfo, errors }} />
    </Grid>
  );
};

export default NewFeeForm;
